module.exports = __webpack_public_path__ + "static/media/tarcio-barreira.2817b5fb.jpg";